export const environment = {
  state: 'production',
  baseUrl: 'https://kip-hub.com',
  nhn: {
    objectStorageContainer: 'test',
  },
};
